export class SwalStyle {

  public getGeneralStyle(): object {
    return {
      'confirmButtonColor' : '#1fcaa2',
      'cancelButtonColor' : '#f6901c'
    };
  }

  public getQuestionStyle(): object {
    return {
      'confirmButtonColor' : '#1fcaa2',
      'cancelButtonColor' : '#f6901c'
    };
  }
  public getLoading(): object {
    return {
      width: '100%',
      'confirmButtonColor' : '#1fcaa2',
      'cancelButtonColor' : '#f6901c',
      background: 'transparent'

    };
  }
  public getErrorStyle(): object {
    return {
      'confirmButtonColor' : '#f1404b'
    };
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/notification/swal/swalStyle.ts